import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-20" data-id="element-112">
      <div className="mx-auto max-w-4xl" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative rounded-3xl border border-line bg-white p-8 text-center shadow-sm sm:p-12" data-id="element-114">
          <div className="absolute inset-x-0 top-0 h-1 rounded-t-3xl bg-violet" data-id="element-115" />
          <div className="mx-auto flex size-20 items-center justify-center rounded-full border-4 border-navy bg-violet-mist" data-id="element-116">
            <ShieldCheckIcon size={40} className="text-violet" data-id="element-117" />
          </div>
          <h2 className="mt-6 font-display text-3xl font-black uppercase text-navy sm:text-4xl" data-id="element-118">
            Full 7-Day Money-Back Guarantee
          </h2>
          <div className="mx-auto mt-6 max-w-2xl space-y-5 text-base leading-relaxed text-slate-600 sm:text-lg" data-id="element-119">
            <p data-id="element-120">
              Open the entire teaching system. Explore all 5 bonuses. Use the
              material in your most challenging class this week.
            </p>
            <p className="font-semibold text-navy" data-id="element-121">
              If you feel the material is not clear, practical, or genuinely
              useful — contact us within 7 days.
            </p>
            <p className="font-bold text-violet" data-id="element-122">
              100% refund. No questions. No forms. No complications.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}